import React from "react"
import { isBrowser, isMobile } from 'react-device-detect';

const Footer = ({ activePage }) => {
    return (
        <footer id='footer' className="position-relative footer mt-auto" style={isBrowser || (isMobile && activePage !== 'Assessment') ? { visibility: 'visible' } : { visibility: 'hidden' }}>
            <span id='copyright-note'>Powered by <b> Labora Holding GmbH</b></span>
            <a href="https://www.labora-holding.de" id="labora-website" className='float-end'><b>Labora Holding GmbH</b></a>
        </footer >
    )
}

export default Footer
